import countryList from './countries.json'
export const countries = countryList

export const REAL_TIME_CLEANING_PERMISSION = 'real-time-cleaning'
export const REAL_TIME_MAINTENANCE_PERMISSION = 'real-time-maintenance'
export const LEGACY_REAL_TIME_PERMISSION = 'real-time'
export const REAL_TIME_PERMISSIONS = [REAL_TIME_CLEANING_PERMISSION, REAL_TIME_MAINTENANCE_PERMISSION]

/** Either tab permission opens the Real time screen. The old `real-time` role does too. */
export function hasRealTimeAccess(roles) {
  if (!Array.isArray(roles)) return false
  return roles.includes(LEGACY_REAL_TIME_PERMISSION) || REAL_TIME_PERMISSIONS.some((permission) => roles.includes(permission))
}

/**
 * A tab permission shows that tab. The old `real-time` role shows both tabs only when
 * neither tab permission is present, so a cleaning-only user is not given maintenance.
 */
export function canSeeRealTimeTab(roles, permission) {
  if (!Array.isArray(roles)) return false
  if (roles.includes(permission)) return true
  const hasSpecificTab = REAL_TIME_PERMISSIONS.some((tab) => roles.includes(tab))
  return !hasSpecificTab && roles.includes(LEGACY_REAL_TIME_PERMISSION)
}

export const sideBarNavItems = [
  {
    name: 'dashboard',
    permission: 'dashboard',
    path: '/dashboard',
  },
  {
    name: 'real_time',
    permissions: REAL_TIME_PERMISSIONS,
    path: '/real-time',
  },
  {
    name: 'cleaner_activity',
    permission: 'cleaner-activity',
    path: '/cleaner-activity',
  },
  {
    name: 'pad_presence_testing',
    permission: 'pad-presence-testing',
    path: '/pad-presence-testing',
  },
  {
    name: 'survey',
    permission: 'survey',
    path: '/survey',
  },
  {
    name: 'rooms',
    permission: 'room',
    path: '/admin/room/list',
  },
  {
    name: 'task',
    permission: 'task',
    path: '/task',
  },
  {
    name: 'users',
    permission: 'users',
    path: '/users',
  },
  {
    name: 'shifts',
    permission: 'shift',
    path: '/shift',
  },
  {
    name: 'devices',
    permission: 'devices',
    path: '/admin/devices',
  },
  {
    name: 'working_area',
    permission: 'working_area',
    path: '/working-area',
  },
]

export const DEVICE_ACTIONS_PERMISSION = 'device-actions'

export const panelPermittedOptions = [
  { name: 'dashboard', id: 'dashboard' },
  { name: 'staff', id: 'staff' },
  { name: REAL_TIME_CLEANING_PERMISSION, id: REAL_TIME_CLEANING_PERMISSION },
  { name: REAL_TIME_MAINTENANCE_PERMISSION, id: REAL_TIME_MAINTENANCE_PERMISSION },
  { name: 'cleaner-activity', id: 'cleaner-activity' },
  { name: 'pad-presence-testing', id: 'pad-presence-testing' },
  { name: 'survey', id: 'survey' },
  { name: 'room', id: 'room' },
  { name: 'task', id: 'task' },
  { name: 'users', id: 'users' },
  { name: 'shift', id: 'shift' },
  { name: 'devices', id: 'devices' },
  { name: DEVICE_ACTIONS_PERMISSION, id: DEVICE_ACTIONS_PERMISSION },
  { name: 'surveyApp', id: 'surveyApp' },
  { name: 'installation', id: 'installation' },
  { name: 'working_area', id: 'working_area' },
  { name: 'chat', id: 'chat' },
  { name: 'executive-report', id: 'executive-report' },
]

export const sideBarAdminNavItems = [
  {
    name: 'franchise',
    permission: 'franchise',
    path: '/admin/franchise',
  },
  {
    name: 'company',
    permission: 'company',
    path: '/admin/company',
  },
  {
    name: 'site',
    permission: 'site',
    path: '/admin/site',
  },
  {
    name: 'user',
    permission: 'user',
    path: '/admin/user',
  },
  {
    name: 'alerts',
    permission: 'device-alerts',
    path: '/admin/device-alerts',
  },
  {
    name: 'site_alerts',
    permission: 'site',
    path: '/admin/site-alerts',
  },
  {
    name: 'change_history',
    path: '/admin/change-history',
    buzzzOnly: true,
  },
]
